import axios from "axios";
import { baseUrl } from "../../Redux/App/app.actions";

export const downloadBurdenMixApi = async (id) => {
  try {
    const response = await axios.get(
      `${baseUrl}/b1/download_compiled_file/${id}`,
      { responseType: "arraybuffer" }
    );
    console.log(response);
    if (response.data) {
      return {
        data: response.data,
      };
    }
  } catch (error) {
    console.log(error);
  }
};
